import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ImageUploadSection = ({
  logoPreview,
  photoPreview,
  onLogoChange,
  onPhotoChange,
  errors
}) => {
  const handleFileChange = (e, type) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    if (file?.size > 5000000) {
      alert('Arquivo muito grande. Máximo 5MB.');
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader?.result;
      if (type === 'logo') {
        onLogoChange(file, result);
      } else {
        onPhotoChange(file, result);
      }
    };
    reader?.readAsDataURL(file);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-6">
      {/*
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Logo da Clínica
        </label>
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center overflow-hidden border-2 border-border">
            {logoPreview ? (
              <Image
                src={logoPreview}
                alt="Logo circular da clínica de psicologia com fundo branco"
                className="w-full h-full object-cover"
              />
            ) : (
              <Icon name="Building2" size={32} color="var(--color-muted-foreground)" />
            )}
          </div>
          <div className="flex-1">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'logo')}
              className="hidden"
              id="logo-upload"
            />
            <label htmlFor="logo-upload">
              <Button
                type="button"
                variant="outline"
                size="sm"
                iconName="Upload"
                iconPosition="left"
                onClick={() => document.getElementById('logo-upload')?.click()}
              >
                {logoPreview ? 'Alterar Logo' : 'Carregar Logo'}
              </Button>
            </label>
            <p className="text-xs text-muted-foreground mt-1">
              PNG, JPG até 5MB
            </p>
            {errors?.logo && (
              <p className="text-xs text-error mt-1">{errors?.logo}</p>
            )}
          </div>
        </div>
      </div>
      */}

      <div className="-mt-2">
        <br />
        <label className="block text-sm font-medium text-foreground mb-2">
          Foto de Perfil
        </label>
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center overflow-hidden border-2 border-border">
            {photoPreview ? (
              <Image
                src={photoPreview}
                alt="Foto profissional circular do psicólogo em traje formal"
                className="w-full h-full object-cover"
              />
            ) : (
              <Icon name="User" size={32} color="var(--color-muted-foreground)" />
            )}
          </div>
          <div className="flex-1">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'photo')}
              className="hidden"
              id="photo-upload"
            />
            <label htmlFor="photo-upload">
              <Button
                type="button"
                variant="outline"
                size="sm"
                iconName="Upload"
                iconPosition="left"
                onClick={() => document.getElementById('photo-upload')?.click()}
              >
                Carregar Foto
              </Button>
            </label>
            <p className="text-xs text-muted-foreground mt-1">
              PNG, JPG até 5MB
            </p>
            {errors?.photo && (
              <p className="text-xs text-error mt-1">{errors?.photo}</p>
            )}
          </div>
        </div>
      </div>
    </div>

  );
};

export default ImageUploadSection;